import React, { useState, ReactElement } from 'react';
import LogInScreen from './LogInScreen';
import AuthenticateUserScreen from './AuthenticateUserScreen';

interface SignInScreenProps {
  newPasswordPath: string;
  email: string;
}

const SignInScreen = ({
  newPasswordPath, email,
}: SignInScreenProps): ReactElement => {
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(true);
  const [userEmail, setUserEmail] = useState<string>(email || '');
  const [userPassword, setUserPassword] = useState<string>('');
  const [sentCode, setSentCode] = useState<boolean>(false);
  const [isRememberable, setIsRememberable] = useState<boolean>(false);
  const [isTwoFactorRequired, setIsTwoFactorRequired] = useState<boolean>(true);
  const [isMfaForcedByOrgAdmin, setIsMfaForcedByOrgAdmin] = useState<boolean>(true);
  const [userPhone, setUserPhone] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [mfaMethod, setMfaMethod] = useState<string>('sms');

  return (
    <>
      {isLoggingIn ? (
        <LogInScreen
          newPasswordPath={newPasswordPath}
          setIsRememberable={setIsRememberable}
          setIsLoggingInFn={setIsLoggingIn}
          userEmail={userEmail}
          setUserEmail={setUserEmail}
          userPassword={userPassword}
          setUserPassword={setUserPassword}
          setUserPhone={setUserPhone}
          setSentCode={setSentCode}
          setFirstName={setFirstName}
          setIsTwoFactorRequired={setIsTwoFactorRequired}
          setIsMfaForcedByOrgAdmin={setIsMfaForcedByOrgAdmin}
          setMfaMethod={setMfaMethod}
        />
      ) : (
        <AuthenticateUserScreen
          sentCode={sentCode}
          setSentCode={setSentCode}
          userEmail={userEmail}
          userPassword={userPassword}
          userPhone={userPhone}
          setUserPhone={setUserPhone}
          isRememberable={isRememberable}
          firstName={firstName}
          isTwoFactorRequired={isTwoFactorRequired}
          isMfaForcedByOrgAdmin={isMfaForcedByOrgAdmin}
          mfaMethod={mfaMethod}
          setMfaMethod={setMfaMethod}
        />
      )}
    </>
  );
};

export default SignInScreen;
